// utils/checkPageStatus.js
import { urls } from "../services/apiService";

export async function checkPageStatus(pageKey) {
  try {
    // Try localStorage first
    const saved = localStorage.getItem("pageSettings");
    let parsed = saved ? JSON.parse(saved) : null;

    // Function to find page by key
    const findPage = (arr) => arr.find((p) => `${p.id}-${p.page_name}` === pageKey);

    if (parsed) {
      const existingPage = findPage(parsed);
      if (existingPage) {
        // Still return the localStorage value first
        // But fetch backend in background to check for updates
        fetchAndUpdate(parsed); // Fire-and-forget
        return existingPage.is_enabled === 1;
      }
    }

    // If not in localStorage, fetch backend immediately
    const response = await fetch(urls.pages);
    if (!response.ok) throw new Error("Failed to fetch page statuses");

    const data = await response.json();
    localStorage.setItem("pageSettings", JSON.stringify(data));

    const match = findPage(data);
    return match ? match.is_enabled === 1 : true;
  } catch (error) {
    console.error("Error checking page status:", error);
    return true; // fail-safe
  }
}

// Helper to fetch backend and update localStorage if changed
async function fetchAndUpdate(oldData) {
  try {
    const response = await fetch(urls.pages);
    if (!response.ok) return;

    const data = await response.json();
    // Compare old vs new data by pageKey and is_enabled
    const changed = data.some((page) => {
      const oldPage = oldData.find((p) => p.id === page.id && p.page_name === page.page_name);
      return !oldPage || oldPage.is_enabled !== page.is_enabled;
    });

    if (changed) {
      localStorage.setItem("pageSettings", JSON.stringify(data));
      console.log("Page settings updated from backend");
    }
  } catch (err) {
    console.error("Error refetching page settings:", err);
  }
}
